import { LitElement } from 'lit-element';

/**
 * Our extension of LitElement. Fires an event when the component is connected,
 * and adds additional useful methods.
 */
export class KatLitElement extends LitElement {
  connectedCallback() {
    window.dispatchEvent(
      new CustomEvent('katal-component-connected', {
        detail: { element: this },
      })
    );

    super.connectedCallback();
  }

  dispatchCustomEvent<T extends {}>(
    eventType: string,
    detail?: T,
    bubbles: boolean = true
  ) {
    const evt = new CustomEvent(eventType, { bubbles, detail });
    this.dispatchEvent(evt);
  }
}
